<div class="container-loading">
  <div class="container-icons">
    <object
      type="image/svg+xml"
      data="../../../../../assets/img/svg/hotel-loader.svg"
    ></object>
  </div>
</div>
